import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FnMenuItemState } from '../models/fn-menu.state';
import { Subject } from 'rxjs';
import { FnMenuDataService } from '../service/fn-menu-data.service';
import { FnMenuEventService } from '../service/fn-menu-event.service';
import { takeUntil } from 'rxjs/operators';
import { FnLocalStorageService } from '../../../services/fn-local-storage.service';

@Component({
	templateUrl: 'fn-menu-landing.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnMenuLandingComponent extends FnLocalStorageService
	implements OnDestroy {
	activeMenuItem: FnMenuItemState;
	isLoaded: boolean;
	isCustMenu: boolean;
	private destroy$: Subject<boolean> = new Subject<boolean>();

	constructor(
		private menuDataSvcs: FnMenuDataService,
		private fnMenuService: FnMenuEventService
	) {
		super();
		this.loadSubMenuArrayForActiveMenuId();
	}

	loadSubMenuArrayForActiveMenuId() {
		this.menuDataSvcs
			.getActiveMenuId$()
			.pipe(takeUntil(this.destroy$))
			.subscribe((menuId) => {
				this.menuDataSvcs
					.getActiveMenuItem()
					.subscribe((menuItem: any) => {
						this.activeMenuItem = menuItem  as FnMenuItemState;
						this.isCustMenu = this.activeMenuItem.menuType === 'CUSTOM';
						this.isLoaded = true;
					});
			});
	}

	menuClickHandler(menuItem: FnMenuItemState) {
		this.setItem('selected_menu', menuItem.id);
		this.fnMenuService.onMenuItemClick(menuItem.id);
	}

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.complete();
	}
}
